var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import _extends from "@babel/runtime/helpers/extends";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["name", "label", "helperText", "onChange", "getListData", "multiple", "defaultValue", "value", "variant", "valueExpr", "displayExpr", "error", "placeholder", "size", "apiKey", "options", "required", "apiRequest", "disableUnderline", "filterMode", "TextFieldProps", "state", "searchFilterPattern"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o);
} return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); });
} return e; }
import { Autocomplete, CircularProgress, debounce, TextField } from "@mui/material";
import { useCallback, useEffect, useState } from "react";
import { ChevronDownIcon } from "../../../../assets/customIcons";
import { deleteState, setReducerState } from "../../../../redux/crudSlice";
import { useAppDispatch, useAppSelector } from "../../../../store/hooks";
import { getDefaultKey, getLoadingKey, getTextFilterFn, getUpdateKey } from "../../../common/commonFunctions";
import { Close } from "@mui/icons-material";
export var FormSearchSelect = function (props) {
    var _crud$apiKey, _crud$defaultKey2, _crud$apiKey2;
    var crud = useAppSelector(function (state) { return state.crud; });
    var dispatch = useAppDispatch();
    var _a = props.name, name = _a === void 0 ? 'Name' : _a, label = props.label, 
    // width,
    helperText = props.helperText, onChange = props.onChange, getListData = props.getListData, _b = props.multiple, multiple = _b === void 0 ? false : _b, _c = props.defaultValue, defaultValue = _c === void 0 ? multiple ? [] : null : _c, _d = props.value, value = _d === void 0 ? null : _d, _e = props.variant, variant = _e === void 0 ? 'outlined' : _e, _f = props.valueExpr, valueExpr = _f === void 0 ? 'id' : _f, _g = props.displayExpr, displayExpr = _g === void 0 ? 'Name' : _g, error = props.error, _h = props.placeholder, placeholder = _h === void 0 ? value !== null && value !== void 0 && value.length ? "" : "Select ".concat(label !== null && label !== void 0 ? label : name) : _h, _j = props.size, size = _j === void 0 ? 'small' : _j, _k = props.apiKey, apiKey = _k === void 0 ? "".concat(name, "_List") : _k, _l = props.options, options = _l === void 0 ? ((_crud$apiKey = crud[apiKey]) === null || _crud$apiKey === void 0 ? void 0 : _crud$apiKey.data) || [] : _l, _m = props.required, required = _m === void 0 ? false : _m, _o = props.apiRequest, apiRequest = _o === void 0 ? {} : _o, _p = props.disableUnderline, disableUnderline = _p === void 0 ? false : _p, _q = props.filterMode, filterMode = _q === void 0 ? 'server' : _q, TextFieldProps = props.TextFieldProps, state = props.state, searchFilterPattern = props.searchFilterPattern, others = _objectWithoutProperties(props, _excluded);
    var _r = useState(defaultValue), selected = _r[0], setSelected = _r[1];
    var loadingKey = getLoadingKey(apiKey);
    var defaultKey = getDefaultKey(apiKey);
    var updateKey = getUpdateKey(apiKey);
    var getSelectedOption = useCallback(function (newValue) { return __awaiter(void 0, void 0, void 0, function () {
        var val, res, _res;
        var _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    if (multiple) {
                        setSelected(newValue !== null && newValue !== void 0 ? newValue : []);
                        return [2 /*return*/];
                    }
                    if (newValue === null || newValue === undefined) {
                        setSelected(null);
                        return [2 /*return*/];
                    }
                    val = options === null || options === void 0 ? void 0 : options.find(function (el) { return el[valueExpr] === newValue; });
                    if (!(!val && getListData)) return [3 /*break*/, 2];
                    return [4 /*yield*/, getListData({
                            key: apiKey + "_id",
                            request: _objectSpread(_objectSpread({}, apiRequest), {}, (_a = {},
                                _a[valueExpr] = newValue,
                                _a)),
                            state: state
                        })];
                case 1:
                    res = _b.sent();
                    val = (_res = res) === null || _res === void 0 || (_res = _res.data) === null || _res === void 0 ? void 0 : _res.find(function (el) { return el[valueExpr] === newValue; });
                    _b.label = 2;
                case 2:
                    dispatch(deleteState({
                        key: apiKey + "_id"
                    }));
                    setSelected(val);
                    return [2 /*return*/];
            }
        });
    }); }, [options, state]);
    useEffect(function () {
        getSelectedOption(value);
    }, [value]);
    useEffect(function () {
        if (crud[updateKey]) {
            dispatch(deleteState({
                key: defaultKey
            }));
            dispatch(deleteState({
                key: apiKey
            }));
            dispatch(deleteState({
                key: updateKey
            }));
        }
        return function () {
            if (!crud[updateKey] && !getListData) {
                dispatch(deleteState({
                    key: defaultKey
                }));
                dispatch(deleteState({
                    key: apiKey
                }));
            }
        };
    }, [crud[updateKey]]);
    var onOpen = useCallback(function (e) { return __awaiter(void 0, void 0, void 0, function () {
        var _crud$defaultKey, res;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if ((_crud$defaultKey = crud[defaultKey]) !== null && _crud$defaultKey !== void 0 && _crud$defaultKey.data) {
                        dispatch(setReducerState({
                            key: apiKey,
                            value: crud[defaultKey]
                        }));
                        return [2 /*return*/];
                    }
                    if (!getListData) return [3 /*break*/, 2];
                    return [4 /*yield*/, getListData({
                            key: apiKey,
                            request: apiRequest,
                            state: state
                        })];
                case 1:
                    res = _a.sent();
                    dispatch(setReducerState({
                        key: defaultKey,
                        value: res
                    }));
                    _a.label = 2;
                case 2: return [2 /*return*/];
            }
        });
    }); }, [apiKey, state, (_crud$defaultKey2 = crud[defaultKey]) === null || _crud$defaultKey2 === void 0 ? void 0 : _crud$defaultKey2.data, (_crud$apiKey2 = crud[apiKey]) === null || _crud$apiKey2 === void 0 ? void 0 : _crud$apiKey2.data]);
    var handleInputChange = useCallback(debounce(function (e, val, details, state) {
        if (details === 'input' && getListData) {
            getListData({
                key: apiKey,
                request: _objectSpread({
                    search: val
                }, apiRequest),
                state: state
            });
        }
    }, 500), [apiKey, apiRequest, getListData]);
    var getOptionLabel = useCallback(function (option) {
        var _option$displayExpr;
        return (_option$displayExpr = option === null || option === void 0 ? void 0 : option[displayExpr]) !== null && _option$displayExpr !== void 0 ? _option$displayExpr : "";
    }, [displayExpr]);
    var getOptionKey = useCallback(function (option) { return option === null || option === void 0 ? void 0 : option[valueExpr]; }, [valueExpr]);
    var isOptionEqualToValue = useCallback(function (option, selectedValue) { return (option === null || option === void 0 ? void 0 : option.hasOwnProperty(valueExpr)) && (selectedValue === null || selectedValue === void 0 ? void 0 : selectedValue.hasOwnProperty(valueExpr)) && (option === null || option === void 0 ? void 0 : option[valueExpr]) === (selectedValue === null || selectedValue === void 0 ? void 0 : selectedValue[valueExpr]); }, [valueExpr]);
    return /*#__PURE__*/ React.createElement(Autocomplete, _extends({
        fullWidth: true,
        multiple: multiple,
        size: size,
        options: options,
        getOptionLabel: getOptionLabel,
        getOptionKey: getOptionKey,
        isOptionEqualToValue: isOptionEqualToValue,
        renderInput: function (params) {
            if (crud[loadingKey] === 'loading')
                params.InputProps.endAdornment = [/*#__PURE__*/ React.createElement(CircularProgress, {
                        color: "secondary",
                        size: 20
                    }), params.InputProps.endAdornment];
            return /*#__PURE__*/ React.createElement(TextField, _extends({}, TextFieldProps, params, {
                variant: variant,
                name: name,
                placeholder: placeholder,
                helperText: helperText,
                InputProps: _objectSpread(_objectSpread(_objectSpread({}, TextFieldProps === null || TextFieldProps === void 0 ? void 0 : TextFieldProps.InputProps), params.InputProps), {}, {
                    disableUnderline: disableUnderline
                })
            }, error && {
                error: true,
                helperText: error
            }));
        },
        popupIcon: /*#__PURE__*/ React.createElement(ChevronDownIcon, {
            fontSize: "small"
        })
    }, others, {
        ChipProps: _objectSpread({
            variant: 'outlined',
            size: 'small',
            color: 'default',
            shape: 'rounded',
            deleteIcon: /*#__PURE__*/ React.createElement(Close, null)
        }, others.ChipProps),
        value: selected,
        onOpen: onOpen,
        onChange: onChange,
        onInputChange: filterMode === 'server' ? function (e, value, reason) { return handleInputChange(e, value, reason, state); } : undefined,
        onInputCapture: searchFilterPattern && getTextFilterFn(searchFilterPattern)
    }));
};
